import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';
import BrandLogo from '@/components/site/BrandLogo';

export default function Footer() {
  return (
    <footer data-testid={FOOTER.section} className="bg-[var(--mw-bg)] border-t border-white/10">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-16 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <BrandLogo size="md" asLink={false} testId="brand-logo-footer" className="mb-6" />
          <p className="text-white/55 max-w-sm leading-relaxed">
            Premium wholesale butchery — beef, lamb, poultry & house-cured
            smallgoods. Cold-chain delivered across WA since 2001.
          </p>
        </div>

        <FooterCol title="Visit">
          <div>15 Action Rd</div>
          <div>Malaga WA 6090</div>
          <div className="pt-2">
            <a href="tel:+61435111667" className="hover:text-white transition-colors">0435 111 667</a>
          </div>
          <div>Mon–Fri · 6am–4pm</div>
          <div>Sat · 7am–12pm</div>
        </FooterCol>

        <FooterCol title="Trade">
          <a href="/#catalog" className="block hover:text-white transition-colors">Catalogue</a>
          <Link to="/wholesale" className="block hover:text-white transition-colors">Wholesale</Link>
          <Link to="/export" className="block hover:text-white transition-colors">Export</Link>
          <Link to="/wholesale-faq" className="block hover:text-white transition-colors">FAQ</Link>
        </FooterCol>

        <FooterCol title="Learn">
          <Link to="/recipes" data-testid="footer-recipes-link" className="block hover:text-white transition-colors">Recipes</Link>
          <Link to="/blog" data-testid="footer-blog-link" className="block hover:text-white transition-colors">Blog</Link>
          <div className="pt-1">Halal Certified</div>
          <div>HACCP Compliant</div>
        </FooterCol>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-6 sm:px-10 lg:px-16 py-6 flex flex-col sm:flex-row gap-3 items-center justify-between text-[11px] uppercase tracking-[0.24em] text-white/40">
          <div>© {new Date().getFullYear()} The Meat Works · Malaga, WA</div>
          <Link
            to="/admin"
            data-testid={FOOTER.adminLink}
            className="hover:text-white transition-colors"
          >
            Trade Console
          </Link>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }) {
  return (
    <div className="lg:col-span-2 lg:col-start-auto">
      <div className="text-[10px] uppercase tracking-[0.28em] text-white/45 mb-4">{title}</div>
      <div className="space-y-2 text-sm text-white/65">{children}</div>
    </div>
  );
}
